import styled from 'styled-components';
import Calendar from 'react-calendar';
import InputStyles from 'admin-components/styles/input';
import { colours, fonts } from 'themes/default';

const { fontStyleRegular } = fonts;

const Input = styled('input')`
  ${InputStyles}
`;

const Label = styled('div')`
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

const InputContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const DatepickerContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  width: ${(props) => {
    if (props.multicity === undefined) {
      return '100%';
    }

    return props.multicity ? '100%' : '48%';
  }};
`;

const StyledCalendar = styled(Calendar)`
  div,
  button {
    ${fontStyleRegular}
  }
  .react-calendar__tile-away-dates {
    background-color: rgba(0, 110, 220, 0.5);
  }

  &.react-calendar {
    width: 100%;
    border: 1px solid ${colours.Shades.TintBlue10};
  }
`;

export { Input, Label, InputContainer, DatepickerContainer, StyledCalendar };
